import { FunctionComponent, useEffect } from 'react'
import config from '@config'
import { QueryClient, useQueryClient } from 'react-query'

const {
  abTest: { windowKey, variantKeys },
} = config

const registerABTestListeners = (queryClient: QueryClient): void => {
  window[windowKey]._registered = true
  variantKeys.forEach((variantKey) => {
    Object.defineProperty(window[windowKey], variantKey, {
      configurable: true,
      enumerable: true,
      set: function (value) {
        queryClient.setQueryData([windowKey, variantKey], value)
        queryClient.invalidateQueries([windowKey, variantKey], {
          exact: true,
        })
        this[`_${variantKey}`] = value
      },
      get: function () {
        return this[`_${variantKey}`]
      },
    })
  })
}

const ABTestManager: FunctionComponent = () => {
  const queryClient = useQueryClient()

  useEffect(() => {
    if (!window[windowKey]._registered) {
      registerABTestListeners(queryClient)
    }
  }, [queryClient])

  return null
}

export default ABTestManager
